// src/utils/common.js

/**
 * 公共方法集合
 */
 //是否显示会员价格
 export function isShowVipPrice(floor,clear,discount) {
    if(localStorage.getItem('aih5AllUser')){
        if(Number(floor) > 0 && clear==2 && Number(discount)>0){
            return true
        }else{
            return false
        }
    }else{
        return false
    }
    
  }
  // 会员价格
  export function getVipPrice(value,discount) {
    var price=((Number(value)*Number(discount))/10).toFixed(2)
    return price
  }
  